import React, { useContext, useRef } from 'react';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import PbxContext from '../../context/PbxContext';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

const ChartCallsStatusByDay = ({ getRows }) => {
  const getItensStateGlobal = useContext(PbxContext);
  const { storageDataReport } = getItensStateGlobal;
  
  const { sendedsDays } = storageDataReport;
  
  const labels = Object.keys(sendedsDays);

  const chartCallsDaysSendedsRef = useRef(null);

  const getDataToRequestFilter = (event) => {
    if (chartCallsDaysSendedsRef.current) {
    const chart = ChartJS.getChart(chartCallsDaysSendedsRef.current);
    const clickedElements = chart.getElementsAtEventForMode(event, 'nearest',{ intersect: true }, true);
    if (clickedElements.length > 0) {
      const firstElement = clickedElements[0];
      let labelType = chart.data.datasets[firstElement.datasetIndex].label;
      const labelIndexClicked = chart.data.labels[firstElement.index];

      labelType === 'Não Atendidas' ? labelType = 'perdida' : labelType = 'atendida';

      getRows('sendeds-days', labelIndexClicked, labelType);
    }
   }
  };

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        // text: 'Chart.js Bar Chart',
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: 'Atendidas',
        data: labels.map((label) => sendedsDays[label].atendidas),
        fill: true,
        backgroundColor: 'rgba(0, 179, 60, 0.7)',
        borderColor: 'rgb(0, 179, 60, 0.5))',
      },
      {
        label: 'Não Atendidas',
        data: labels.map((label) =>  sendedsDays[label].perdidas),
        fill: true,
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
      }
    ]
  };

  return (
    <div className={ labels.length >= 2 ? 'column is-half' : 'column is-half is-hidden' } >
      <h2 className="has-text-centered is-size-5">Status das Chamadas Realizadas por Dia</h2>
        <Bar options={options} data={data} plugins={[ChartDataLabels]} ref={chartCallsDaysSendedsRef} getElementAtEvent={(_, event) => getDataToRequestFilter(event)} />
    </div>
  );
}

export default ChartCallsStatusByDay;
